import React, { useState } from "react";

const ImageGallery = ({ images = [] }) => {
  // State to hold the index of the currently selected image
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  return (
    <div className="flex md:!h-[424px] flex-wrap md:!flex-nowrap overflow-hidden items-stretch gap-4 md:!gap-0">
      {/* Main Image Display */}
      <div className="w-full md:w-[754px]">
        <img
          // src={images[selectedImageIndex]}
          src={`https://zv.shellcode.cloud/upload/${images[selectedImageIndex]}`}
          alt={`Not Found`}
          // alt={`Main view of ${images[selectedImageIndex]}`}
          className="rounded-lg w-full h-full object-cover"
        />
      </div>

      {/* Thumbnail Images */}
      <div className="flex flex-row md:!flex-col h-full ml-0 md:ml-4 gap-4">
        {Array.isArray(images) &&
          images?.map((image, index) => (
            <img
              key={image}
              src={`https://zv.shellcode.cloud/upload/${image}`}
              alt={`Not Found`}
              onClick={() => setSelectedImageIndex(index)}
              className={`w-[235px] xs:!h-[138px] overflow-hidden rounded-lg cursor-pointer object-cover ${
                index === selectedImageIndex ? "border-2 border-blue-500" : ""
              }`}
            />
          ))}
      </div>
    </div>
  );
};

export default ImageGallery;
